import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks/useQueryParams';

export function useGuideQueryParams() {
	const {setSearchParams} = useQueryParams();

	const deleteAllQueryParams = () => {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.STEP);
				prev.delete(QueryParamsEnum.COORDINATES);
				prev.delete(QueryParamsEnum.UF_CODE);
				prev.delete(QueryParamsEnum.CITY_NAME);
				prev.delete(QueryParamsEnum.DISTRICT_NAMES);
				prev.delete(QueryParamsEnum.SERVICE_TYPE);
				prev.delete(QueryParamsEnum.SPECIALTY_CODE);
				prev.delete(QueryParamsEnum.SPECIALTY_NAME);
				prev.delete(QueryParamsEnum.NETWORK_CODE);
				prev.delete(QueryParamsEnum.NETWORK_TYPE);
				prev.delete(QueryParamsEnum.ORDER_BY);
				prev.delete(QueryParamsEnum.COMING_FROM);
				prev.delete(QueryParamsEnum.PROCEDURE);
				return prev;
			},
			{replace: true},
		);
	};

	const deleteQuerySelectsParams = () => {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SERVICE_TYPE);
				prev.delete(QueryParamsEnum.SPECIALTY_CODE);
				prev.delete(QueryParamsEnum.SPECIALTY_NAME);
				prev.delete(QueryParamsEnum.NETWORK_CODE);
				prev.delete(QueryParamsEnum.NETWORK_TYPE);
				return prev;
			},
			{replace: true},
		);
	};

	return {
		deleteAllQueryParams,
		deleteQuerySelectsParams,
	};
}
